export default __webpack_public_path__ + "static/ayvakit-logo-og-25mgtablets-ae7f2633d4af940a99c837e9277beb8d.png";